import { render, staticRenderFns } from "./restore-dialog.vue?vue&type=template&id=13e2396e&class=confirm-dialog&"
import script from "./restore-dialog.vue?vue&type=script&lang=js&"
export * from "./restore-dialog.vue?vue&type=script&lang=js&"
import style0 from "./restore-dialog.vue?vue&type=style&index=0&id=13e2396e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports